export function salesPageApiBase() {
  const dev = import.meta.env.VITE_DEV_CF_API_URL || "";
  const stable = import.meta.env.VITE_STABLE_CF_API_URL || "";
  // A local payments worker can serve this route. The legacy host in
  // VITE_DEV_CF_API_URL does not have /sales-pages/:company/:page, so a
  // published page 404s there even though cf.api-atomicpay.com has it.
  if (import.meta.env.DEV && /localhost|127\.0\.0\.1/.test(dev)) return dev;
  return stable || dev;
}

export const SALES_BUILDER_SOURCE = "atomicpay-sales-builder";
export const CHECKOUT_EMBED_SOURCE = "atomicpay-checkout-embed";
